module.exports = __webpack_public_path__ + "img/querzugkraft.7e634742.jpg";